import { isProd } from "@/config/common";
import {
  ContentfulLocaleEnum,
  CountryCodeEnum,
  CountryNameEnum,
  CurrencyCodeEnum,
  DomainEnum,
  ElevateCodeEnum,
  LanguageCodeEnum,
  type Market,
  PSPEnum,
  SiteLocaleEnum,
  SiteNameEnum,
} from "./i18n-config";

export const dk: Market = {
  psp: PSPEnum.WALLEY,
  flag: "🇩🇰",
  currency: CurrencyCodeEnum.DKK,
  countryCode: CountryCodeEnum.DK,
  countryName: CountryNameEnum.DK,
  languageCode: LanguageCodeEnum.DK,
  locale: `${LanguageCodeEnum.DK}-${CountryCodeEnum.DK}`,
  upperCaseLocale: `${LanguageCodeEnum.DK}-${CountryCodeEnum.DK.toUpperCase()}`,
  contentfulLocale: ContentfulLocaleEnum.DK,
  siteLocale: SiteLocaleEnum.DK,
  elevateMarket: ElevateCodeEnum.DK,
  externalStoreId: "ecom-dk",
  walleyStoreCodeB2B: isProd() ? 11451 : 6354,
  walleyStoreCodeB2C: isProd() ? 11450 : 6353,
  searchPathName: "/sogning",
  domain: DomainEnum.NOGA,
  imageCdn: isProd()
    ? "https://cdn.no-ga.com"
    : "https://media.stage.cdn-norce.tech/1413",
  siteName: SiteNameEnum.DK,
};
